import { useQuery } from '@tanstack/react-query';

import { getYardCapacityUtilization } from '@/service/yardCapacityService';
import { useAppSelector } from '@/store';

import type { YardCapacityUtilization } from '@/service/types/yardCapacityTypes';

// ─────────────────────────────────────────────────────────────────
// Query Keys
// ─────────────────────────────────────────────────────────────────

export const yardCapacityQueryKeys = {
  all: ['yardCapacity'] as const,
  utilization: (orgId: string) => ['yardCapacity', 'utilization', orgId] as const,
};

// ─────────────────────────────────────────────────────────────────
// Query Hook — Matches Xamarin YMSCapacityDashboardPageViewModel.GetYardCapacityData()
// OIC direct — no function code needed, just org_id
// ─────────────────────────────────────────────────────────────────

export const useYardCapacityQuery = () => {
  const orgId = useAppSelector((state) => String(state.user.plant?.org_id ?? ''));

  return useQuery({
    queryKey: yardCapacityQueryKeys.utilization(orgId),
    queryFn: async (): Promise<YardCapacityUtilization | null> => {
      return getYardCapacityUtilization();
    },
    enabled: !!orgId,
    staleTime: 2 * 60 * 1000,
  });
};
